import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import Button from '../../Common/Button/Button';
import styles from './Component3.module.scss';
import homeStyles from '../../../styles/Home.module.scss';
import { DataLakeVisual } from './DataLakeVisual';

const Component3 = () => {
  const data: string[] = [
    'Up-to-Date Insights',
    'Cleansed and Validated',
    'Harmonised and Normalised',
    'Comprehensive Coverage',
    'Actionable Insights',
    'Multiple Data Source',
  ];

  const customerList: string[] = [
    '/Amazon-icon.png',
    '/walmart-icon.png',
    '/target-logo.png',
    '/kroger-logo.png',
    '/albertsons-icon.png',
    '/99acres-logo.png',
    '/property-finder.png',
    '/dubizzle-logo.png',
    '/nykaa.webp',
    '/blinkit-icon.png',
  ];

  const sectionRef = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setRevealed(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const handleMouseMove = (event: React.MouseEvent<HTMLLIElement>) => {
    const el = event.currentTarget;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${event.clientX - rect.left}px`);
    el.style.setProperty('--my', `${event.clientY - rect.top}px`);
  };

  return (
    <div
      ref={sectionRef}
      className={`${styles['new-container']} ${
        revealed ? styles['revealed'] : ''
      }`}
    >
      <div className={styles['left-col']}>
        <DataLakeVisual />
      </div>

      <div className={styles['right-col']}>
        <p className={styles['eyebrow']}>Retail data lake</p>
        <h2 className={styles['main-heading']}>
          Discover data set through our <br />
          <span className={homeStyles['span-gradient']}>Retail Data Lake</span>
        </h2>
        <p className={styles['subtext']}>
          All the tools you need to effortlessly discover, collect, and curate
          web data at scale. From initial training to fine-tuning your models —
          we&apos;ve got you covered.
        </p>

        <ul className={styles['feature-list']}>
          {data.map((item, index) => (
            <li
              key={index}
              className={styles['feature-item']}
              onMouseMove={handleMouseMove}
              style={{ '--i': index } as React.CSSProperties}
            >
              <span className={styles['item-glow']} aria-hidden="true" />
              <span className={styles['check-icon']}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12.5L10 17.5L19 6.5"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className={styles['feature-text']}>{item}</span>
            </li>
          ))}
        </ul>

        <div className={styles['dataset-section']}>
          <p className={styles['dataset-heading']}>Dataset of 100+ web apps</p>
          <div className={styles['logos-list']}>
            {customerList.map((path, index) => (
              <div key={index} className={styles['logo-box']}>
                <Image
                  src={path}
                  width={30}
                  height={30}
                  alt="logo"
                  style={{ objectFit: 'contain' }}
                />
              </div>
            ))}
            <div className={styles['plus-box']}>
              <span>+91</span>
            </div>
          </div>
        </div>

        <Link href="/eTail-data-lake" className={styles['cta-link']}>
          <Button text="Know More" />
        </Link>
      </div>
    </div>
  );
};

export default Component3;
